import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import Read from "../../../../../styles/img/read.png"
import TakeTest from "../../../../../styles/img/take-test.png"
import EarnKnowledge from "../../../../../styles/img/earn-knowledge.png"
import {UiHowSectionWorkCol,UiHowSectionWorkColHeading} from"../../../components/common/UiHowSectionWorkCol"

export default function HowKnowledgeWork(props) {


    return (
        <>
            <UiSingleRow>
                <UiCol lg="2">
                    <UiHowSectionWorkColHeading title="How to learn and earn"/></UiCol>
                <UiCol lg="10">
                    <UiSingleRow>
                        <UiHowSectionWorkCol heading="Read Up" image={Read } content="Ensure you know your apples from  your pears."/>
                        <UiHowSectionWorkCol heading="Take Test" image={TakeTest } content="Get comfy, grab a drink and dive into your short test."/>
                        <UiHowSectionWorkCol heading="Earn" image={EarnKnowledge } content="Hit the pass mark to enjoy the fruits of being a genius. More points in your account. "/>
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </>
    )
}
